module.exports = __webpack_public_path__ + "img/facebook.dc70e218.svg";